import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all purchase orders
export const fetchPurchaseOrders = createAsyncThunk(
  "purchase_orders/fetchAll",
  async (page = 1, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/purchase-orders?page=${page}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);


// add purchase orders
export const addPurchaseOrders = createAsyncThunk(
  "purchase_orders/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/purchase-orders/store`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// get purchase orders record
export const purchaseOrdersRecord = createAsyncThunk(
  "purchase_orders/purchaseOrdersRecord",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/purchase-orders/show/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue({ message });
    }
  }
);
// update purchase orders
export const updatePurchaseOrders = createAsyncThunk(
  "purchase_orders/updatePurchaseOrders",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/purchase-orders/update`,
        { business_sector_id: id, ...formData },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
            Lang: i18n.language,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// delete purchase orders
export const deletePurchaseOrders = createAsyncThunk(
  "purchase_orders/deletePurchaseOrders",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/purchase-orders/delete`,
        { business_sector_id: id },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to delete driver";
      return rejectWithValue({ message });
    }
  }
);
const PurchaseOrdersSlice = createSlice({
  name: "purchase_orders",
  initialState: {
    purchase_orders: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
    successDelete: null,
    errorDelete: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPurchaseOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.purchase_orders = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchPurchaseOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(addPurchaseOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addPurchaseOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addPurchaseOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(purchaseOrdersRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(purchaseOrdersRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(purchaseOrdersRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updatePurchaseOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePurchaseOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updatePurchaseOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deletePurchaseOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePurchaseOrders.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside purchase orders
        if (state.purchase_orders?.data) {
          state.purchase_orders.data = state.purchase_orders.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.successDelete = action.payload?.message || "Deleted successfully";
      })
      .addCase(deletePurchaseOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.errorDelete =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete driver";
      });
  },
});

export const { clearState } = PurchaseOrdersSlice.actions;
export default PurchaseOrdersSlice.reducer;
